import DoceboAPI, { DoceboCourseSessionsResponse } from '@/lib/DoceboAPI';
import Vue from 'vue';
import Vuex, { ActionTree, GetterTree, MutationTree } from 'vuex';

interface LocalState {
  courseSessions: { [courseId: string]: DoceboCourseSessionsResponse };
}

Vue.use(Vuex);

const doceboAPI = DoceboAPI.instance;

const namespaced = true;

const localState: LocalState = {
  courseSessions: {},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<LocalState, any> = {};

const mutations: MutationTree<LocalState> = {
  SET_COURSE_SESSIONS: (
    state,
    payload: {
      courseId: string;
      courseSessions: DoceboCourseSessionsResponse;
    }
  ) => {
    Vue.set(state.courseSessions, payload.courseId, payload.courseSessions);
  },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const actions: ActionTree<LocalState, any> = {
  GET_COURSE_SESSIONS: (context, courseId: string): Promise<void> =>
    doceboAPI
      .getCourseSessions(courseId)
      .then((courseSessions: DoceboCourseSessionsResponse) => {
        context.commit('SET_COURSE_SESSIONS', {
          courseId,
          courseSessions,
        });
      }),

  JOIN_WEBINAR: (
    _context,
    payload: {
      courseId: string;
      sessionId: string;
      date: string;
    }
  ) =>
    doceboAPI.joinWebinarSession(
      payload.courseId,
      payload.sessionId,
      payload.date
    ),

  JOIN_SESSION_EVENT: (_context, eventId: string) =>
    doceboAPI.joinSessionEvent(eventId),
};

export { namespaced, localState as state, getters, mutations, actions };
